export const GLOBAL_STATE = 'Student-quiz-assessment'

export const STUDENT_QUIZ_LIST = 'STUDENT_QUIZ_LIST'
export const STUDENT_QUIZ_ALL = 'STUDENT_QUIZ_ALL'
export const STUDENT_QUIZ_BY_ID = 'STUDENT_QUIZ_BY_ID'
export const STUDENT_QUIZ_SAVE = 'STUDENT_QUIZ_SAVE'
export const STUDENT_QUIZ_SELECT = 'STUDENT_QUIZ_SELECT'
export const STUDENT_QUIZ_SUBMIT = 'STUDENT_QUIZ_SUBMIT'
export const STUDENT_QUIZ_START = 'STUDENT_QUIZ_START'
export const STUDENT_QUIZ_SUBMIT_MANUAL = 'STUDENT_QUIZ_SUBMIT_MANUAL'
